/* eslint-disable */
import $g from './Global'
import Caller from './Caller'

/**
 * cx.base
 * 类-Base
 *
 * @class
 * @memberof    cx
 * @author      Zhang Fayong
 * @since       2018-04-28
 */
class Base
{
  /**
   * @constructor
   */
  constructor()
  {
    this._newId = 0
    this._nextZIndex = 1000
    this.debug = false
  }

  /**
   * 比较v1和v2两个版本的大小
   * @param {string|number} v1 第一个版本值，如：'1.1.2' 或数值
   * @param {string|number} v2 第二个版本值
   * @returns {number}         判断的值，0是相等，1是v1大于v2，-1是v1小于v2
   */
  static compareVersions(v1, v2)
  {
    var s1 = ('' + v1).split('.')
    var s2 = ('' + v2).split('.')
    for (var i = 0; i < Math.max(s1.length, s2.length); i++)
    {
      var n1 = parseInt(s1[i] || '0', 10)
      var n2 = parseInt(s2[i] || '0', 10)
  
      if (n1 > n2)
        return 1

      if (n2 > n1)
        return -1
    }
  
    return 0
  }

  /**
   * 产生一个新ID
   * @static
   * @method
   * @returns {Number}
   */
  static nextId()
  {
    return this._newId++
  }

  /**
   * 产生一个新 z-index
   * @static
   * @method
   * @returns {Number}
   */
  static nextZIndex()
  {
    this._nextZIndex += 2     //对话框，对话框下面的模态对话
    return this._nextZIndex
  }

  /**
   * 判断是否Boolean类型，是时返回true，否则false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isBoolean(val)
  {
    return typeof val === 'boolean'
  }

  /**
   * 判断是否定义，不等于undefined时返回true，否则false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isDef(val)
  {
    return val !== undefined
  }

  /**
   * 判断val是否为空，等于null时返回true，否则false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isNull(val)
  {
    return val === null
  }

  /**
   * 判断val已定义且不为null，即有赋值时返回true，否则false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isNNull(val)
  {
    return val !== undefined && val !== null
  }

  /**
   * 判断val是否为数值，是返回true，不是返回false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isNum(val)
  {
    return typeof val === 'number' && !isNaN(val)
  }

  /**
   * 判断val是否为字符串，是返回true，不是返回false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isStr(val)
  {
    return typeof val === 'string' || val instanceof String
  }

  /**
   * 判断val是否为数组，是返回true，不是返回false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isArr(val)
  {
    return val instanceof Array
  }

  /**
   * 判断val是否为对象，是返回true，不是返回false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isObj(val)
  {
    return val && (typeof val === 'object' || typeof val === 'function')
  }

  /**
   * 判断val是否为函数，是返回true不是返回false
   * @static
   * @method
   * @param   {Object}    val
   * @returns {Boolean}
   */
  static isFunc(val)
  {
    return typeof val === 'function'
  }

  /**
   * 如果给出的值为未定义，则给出缺省值
   * @static
   * @method
   * @param   {Object}  value            值
   * @param   {Object}  defValue         缺省值
   * @returns {Object}
   */
  static defVal(value, defValue)
  {
    return value !== undefined ? value : defValue
  }

  /**
   * 判断val(对象或者属性)是否在obj(数组或者对象)中
   * @static
   * @method
   * @param   {Object|Array}  obj
   * @param   {Object}        val
   * @returns {Boolean}
   */
  static contains(obj, val)
  {
    let i
    if (this.isArr(obj))
    {
      for (i = 0; i < obj.length; i++)
      {
        if (obj[i] === val)
          return true
      }
    }
    else if (this.isObj(obj))
    {
      for (i in obj)
      {
        if (obj[i] === val)
          return true
      }
    }
    return false
  }

  /**
   * 目标对象(target)继承对象(args可以多个参数)
   * @static
   * @method
   * @param   {Object}    target          目标对象
   * @param   {Object}    argvs           可变参数
   * @returns {Object}                    target
   */
  static extend(target, ...argvs)
  {
    for (let argv of argvs)
    {
      if (typeof argv === 'object')
      {
        for (let key in argv)
          target[key] = argv[key]
      }
    }
    return target
  }

  /**
   * Funciton或Caller调用
   * @static
   * @method
   * @param   {cx.Caller}     func         函数或者Caller
   * @param   {String}        argvs       可变参数,参数1，参数2，..参数n
   * @returns {*}
   */
  static call(func, ...argvs)
  {
    if (!func)
      return undefined

    //调用
    if (typeof func === 'function')
      return func.apply(null, argvs)
    else if (func instanceof Caller)
    {
      let func1
      if (func.obj)
      {
        func1 = func.obj[func.func]
        if (func1)
          return func1.apply(func.obj, argvs)
      }
      else
      {
        func1 = func.func
        if (func1)
          return func1.apply(null, argvs)
      }
    }
  }

  /**
   * 字符串调用
   * @static
   * @method
   * @param  {String}   func            函数字符串,可以'()'结束，也可以没有'()' (如 'test' 或 'test()')
   * @param  {Array}    argvs           参数数组
   * @returns {*}
   */
  static execute(func, argvs)
  {
    if (func)
    {
      let parent = window
      let obj = window
      let strs = func
      if (strs.indexOf('()') >= 0)				                    //去掉()
        strs = strs.slice(0, -2)
      strs = strs.split('.')						                      //查找包名
      for (let i = 0; i < strs.length; i++)
      {
        parent = obj
        obj = obj[strs[i]]
      }
      if (obj)									                              //执行函数
        return obj.apply(parent, argvs)
    }
  }

  /**
   * 确定显示中英文字符串
   * @static
   * @method
   * @param   {String}    dispc       中文字符串
   * @param   {String}    dispe       英文字符串
   * @param   {String}
   */
  static locale(dispc, dispe)
  {
    return $g.loc ? dispc : dispe
  }

  /**
   * 取字词表符串
   * @static
   * @method
   * @param   {String}    key           字符串key
   * @param   {*}         argvs         变参，要被替换的目标字符串
   * @returns {String}                  词表字符串
   */
  static loc(key, ...argvs)
  {
    let ret = vm.$t(key)
    if (argvs.length > 0)
    {
      for (let i = 0; i < argvs.length; i++)
        ret = ret.replace('%' + (i + 1), '' + argvs[i])
    }
    return ret
  }

  /**
   * 显示信息
   * @static
   * @method
   * @param {String}    message       消息文本
   * @param {String}    [type]        类型(success/warning/info/error)
   */
  static showMsg(message, type)
  {
    if (!type)
      vm.$message(message)
    else
    {
      if (type === 'error')
        vm.$message.error(message)
      else
        vm.$message({type: type, message: message})
    }
  }

  /**
   * 输出调试信息
   * @static
   * @method
   * @param  {String}     msg
   */
  static log(msg)
  {
    if (this.debug)
      console.log(msg)
  }

  /**
   * 设置计时器，来监测条件满足时执行回调
   * @static
   * @method
   * @param   {Function}    isReady     是否满足条件的判断函数
   * @param   {Function}    callBack    满足条件后的回调函数
   * @param   {Number}      [time=600] 间隔时间(ms)。
   */
  static watch(isReady, callBack, time = 200)
  {
    let func = _ =>
    {
      if (isReady())
      {
        if (myInterval)
          window.clearInterval(myInterval)
        callBack()
      }
    }
    //设置定时任务，每1000ms执行一次watch方法。
    let myInterval = window.setInterval(func, time)
  }
}

Base._newId = 0
Base._nextZIndex = 1000
Base.debug = false
Base.processing =
{
  _loads: [],
  _getDom(target)
  {
    if (target)
      return Base.isStr(target) ? document.getElementById(target) || document.body : target
    else
      return document.body
  },
  /**
   * 显示控件
   * @method
   * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
   */
  show(target)
  {
    let dom = this._getDom(target)
    this.loading = vm.$loading({
      lock: true,
      text: vm.$loc('cx.processing'),
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.5)',
      customClass: 'cx-processing',
      target: dom
    })

    this._loads.push({dom: dom, load: this.loading})
  },
  /**
   * 关闭控件
   * @method
   * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
   */
  close(target)
  {
    let dom = this._getDom(target)
    let idx = this._loads.findIndex(item => item.dom === dom)
    let loadObj = this._loads[idx]
    
    if (!loadObj && this._loads.length === 1)
    {
      loadObj = this._loads[0]
      idx = 0
    }

    if (loadObj && loadObj.load)
    {
      loadObj.load.close()
      this._loads.splice(idx, 1)
    }
  }
}
export default Base



// WEBPACK FOOTER //
// ./src/lib/Base.js